// eslint-disable-next-line import/no-cycle
import { DataService } from '../../../config/dataService/dataService';
import { getQueryString } from '../../../utility/utility';

export const getPackageApi = (data) => DataService.get(`/packages?${getQueryString(data)}`);
export const getNextPagePackageApi = (data) => DataService.get(`/packages?${getQueryString(data)}`);
export const getPackageByIdApi = (id) => DataService.get(`/package/${id}`);
export const getPackageSourceApi = (packageId, type) => DataService.get(`/package/${packageId}/source?type=${type}`);
export const updatePackageApi = (data) => DataService.patch(`/package/${data?.id}`, { package_name: data.name });
export const createPackageApi = (data) => DataService.post(`/packages`, data);
export const updatePackageStatusApi = (id, status) => DataService.put(`/package/${id}/status`, { status });
